

import Vue from 'vue';

import * as PatternStore from '@/store/search/form/patterns';
import * as ConceptStore from '@/store/search/form/conceptStore';

import SelectPicker from '@/components/SelectPicker.vue';
import ConceptSearchBox from './ConceptSearchBox.vue'

export default Vue.extend ({
	components: { ConceptSearchBox, SelectPicker },
	name: 'ConceptSearch',
	data: () => ({
		showQuery : false,
	}),
	computed : {
		settings: ConceptStore.get.settings,
		query_from_store() { return ConceptStore.getState().query },
		query_cql_from_store() { return ConceptStore.getState().query_cql },

		concept: {
			get(): string|null { return PatternStore.getState().concept; },
			set: PatternStore.actions.concept,
		},
		element_searched: {
			get(): string|null { return ConceptStore.getState().target_element; },
			set: ConceptStore.actions.setTargetElement,
		},
	},

	methods : {
		updateSubquery(index: number, query: ConceptStore.AtomicQuery[]) {
			ConceptStore.actions.updateSubquery({index, query});
		},
		addBox() { ConceptStore.actions.addSubquery(undefined); },
		removeBox() { ConceptStore.actions.removeSubquery(undefined); },
		resetQuery() { ConceptStore.actions.reset(); },
	}
});

